import { usePortfolioGroupVersionStatData } from "../../usePortfolioGroupVersionStatData";
import { usePortfolioGroupParams } from "@app/hooks/usePortfolioGroupParams";
import { usePortfolioGroupInfo } from "../../usePortfolioGroupInfo";
import { TablePlaceHolder } from "@app/components/PlaceHolder";
import { ChartMultiPeriodReturnComparison } from "./../ChartMultiPeriodReturnComparison";
import { CarPageContentCode, usePageContent } from "@app/hooks/usePageContent";
import { CarPageContent } from "@app/components/PageContent";
import { TableMultiPeriodReturnComparison } from "./../TableMultiPeriodReturnComparison";
import { AnalyzeModuleStyledPage } from "./AnalyzeModuleStyledPage";
import { useAnalyzeModuleChartDataSelector } from "./useAnalyzeModuleChartDataSelector";
import { CarDownloadButton } from "@app/components/Buttons";
import { openInNewTab } from "@app/utils";
import {
  assetAllocationPages,
  portfolioAnalysisPages,
} from "@app/const/route.const";
import { UsePortfolioGroupVersionDataParams } from "../../usePortfolioGroupVersionData";

interface AnalyzeModuleMultiPeriodReturnProps {
  versionParams: UsePortfolioGroupVersionDataParams;
  moduleId: string;
  moduleIdx: number;
}

export const AnalyzeModuleMultiPeriodReturn = (
  props: AnalyzeModuleMultiPeriodReturnProps,
) => {
  const { portfolioGroupId } = usePortfolioGroupParams();

  const pageContent = usePageContent();

  const { moduleId, moduleIdx } = props;

  const groupInfo = usePortfolioGroupInfo({ portfolioGroupId });

  const statData = usePortfolioGroupVersionStatData(props.versionParams);

  const defaultIds = statData.getDefaultDataIdsForModule(moduleId);

  const chartDataSelector = useAnalyzeModuleChartDataSelector({
    portfolioGroupVersionId: props.versionParams.versionId,
    ...defaultIds,
  });

  const handleShowPdf = () => {
    if (chartDataSelector.data1Id && chartDataSelector.data2Id) {
      const params = {
        portfolioGroupId,
        moduleId: props.moduleId,
        data1Id: chartDataSelector.data1Id,
        data2Id: chartDataSelector.data2Id,
      };
      openInNewTab(
        groupInfo.isSinglePortfolioMode
          ? portfolioAnalysisPages.getPdfMultiPeriodReturnReportUrl(params)
          : assetAllocationPages.getPdfModuleMultiPeriodReturnReportUrl(params),
      );
    }
  };

  return (
    <AnalyzeModuleStyledPage>
      <TablePlaceHolder
        isLoading={
          groupInfo.isLoading || statData.isLoading || pageContent.isLoading
        }
        rows={5}
      >
        <CarPageContent
          isWhiteContext
          content={pageContent.getContent(
            groupInfo.isSinglePortfolioMode
              ? CarPageContentCode.PORTFOLIO_ANALYSIS_ANALYZE_MULTI_PERIOD_RETURN
              : CarPageContentCode.ANALYZE_PORTFOLIO_GROUP_REPORTS_MODULE_MULT_PER_RETURN,
          )}
        />
        <CarDownloadButton
          onClick={handleShowPdf}
          sx={{ mt: 2, zIndex: 1, ml: "auto", alignSelf: "flex-end" }}
        >
          Download PDF
        </CarDownloadButton>
        <ChartMultiPeriodReturnComparison
          selectorLabel1="Portfolio Variation 1"
          selectorLabel2="Portfolio Variation 2"
          data={statData.multiPeriodReturnComparison}
          chartDataSelector={chartDataSelector}
          pendoPrefix={`module_${moduleIdx}_multi_period_return_comparison`}
        />
        <TableMultiPeriodReturnComparison
          sx={{ mt: 5 }}
          data={statData.multiPeriodReturnComparison}
          chartDataSelector={chartDataSelector}
        />
      </TablePlaceHolder>
    </AnalyzeModuleStyledPage>
  );
};
